import React from "react";
import { Button, Input, Modal, Select, Switch } from "antd"
import TextArea from "antd/lib/input/TextArea"
import "./discounts.css"
import { Checkbox, FormControlLabel, withStyles } from "@material-ui/core";
import { useAddUpdateDiscountHook, useDiscounthook } from "../../hooks/discounts";

const GreenCheckbox = withStyles({
   root: {
      '&$checked': {
         color: '#43a047',
      },
   },
})((props) => <Checkbox color="default" {...props} />);

export const AddUpdateDiscountModal = ({
   getDiscountList = () => { },
   deleteDiscountEditData = {},
   showAddDiscountModal = false,
   isEdit = false,
   handleSubmit = () => { },
   toggleAddDiscountModal = () => { }
}) => {
   const {
      discountData,
      isLoading,
      errorMessages,
      handleInputChange,
      handleSwitchChange,
      handleDiscountSubmit,
      setDiscountData,
      setErrorMessages,
      handleCheckboxChange,
   } = useAddUpdateDiscountHook({
      getDiscountList,
      deleteDiscountEditData,
      showAddDiscountModal,
      isEdit,
      handleSubmit,
      toggleAddDiscountModal
   })
   return (
      <Modal
         visible={showAddDiscountModal}
         closable={true}
         title={(isEdit ? "Edit" : "Add") + " Discounts"}
         onCancel={toggleAddDiscountModal}
         footer={[
            <Button
               className={'ml-2'}
               key="back"
               onClick={toggleAddDiscountModal}
            >
               Cancel
            </Button>,
            <Button
               className={'ml-2'}
               key="submit"
               type="primary"
               loading={isLoading}
               onClick={handleDiscountSubmit}
            >
               Submit
            </Button>
         ]}
      >
         <div>

            <div className='mb-3 flex'>
               <div className='w-100'>
                  <div>Title</div>
                  <Input
                     name={"title"}
                     value={discountData.title || ""}
                     placeholder="Enter a version name"
                     onChange={handleInputChange}
                  />
                  {errorMessages.title && <span className='error-message'>{errorMessages.title}</span>}
               </div>
            </div>
            <div className='w-100'>
               <div>Description</div>
               <TextArea
                  name={"description"}
                  value={discountData.description || ""}
                  placeholder="Enter app version description"
                  rows={4}
                  onChange={handleInputChange}
               />
               {errorMessages.description && <span className='error-message'>{errorMessages.description}</span>}
            </div>

            <div className='mb-3 flex'>
               <div className='w-100'>
                  <div>Discount</div>
                  <Input
                     name={"discount"}
                     value={discountData.discount || ""}
                     placeholder="Enter a discount amount"
                     onChange={handleInputChange}
                  />
                  {errorMessages.discount && <span className='error-message'>{errorMessages.discount}</span>}
               </div>
            </div>

            <div className='mb-3 flex'>
               <div className='w-100'>
                  <div>Max Discount</div>
                  <Input
                     name={"max_discount"}
                     value={discountData.max_discount || ""}
                     placeholder="Enter a max discount amount"
                     onChange={handleInputChange}
                  />
                  {errorMessages.max_discount && <span className='error-message'>{errorMessages.max_discount}</span>}
               </div>
            </div>

            <FormControlLabel
               control={
                  <GreenCheckbox
                     size="small"
                     name={"is_percentage"} />}
               // id={kycDocumentTypeIndex}
               label={"Percentage (%)"}
               checked={discountData.is_percentage}
               onChange={(e) => handleCheckboxChange(e.target.checked, "is_percentage")}
            />

            <div className="flex mb-6">
               <Switch
                  checked={discountData.status === "true" || discountData.status === true || false}
                  onChange={(isChecked) => handleSwitchChange(isChecked, "status")}
               />
               <div className="mx-2">Status</div>
            </div>

         </div>
      </Modal >
   )
}